import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useDomesticHelperFlow from "../../../../hooks/useDomesticHelperFlowSimple";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import { selectDomesticHelperPremium } from "../../../../redux/features/domesticHelperFormSlice";
import { formatPremiumWithCurrency } from "../../../../utils/index";
import DomesticHelperBottomStickyBtnLayout from "../../layouts/DomesticHelperBottomStickyBtnLayout";
import DomesticHelperJourneyLayout from "../../layouts/DomesticHelperJourneyLayout";

const PlanSelection = () => {
  const translate = useLanguageTranslate();
  const { i18n } = useTranslation();
  const { handleNextStep, handlePrevSubstep } = useDomesticHelperFlow();

  // Get current locale for number formatting
  const currentLocale = i18n.resolvedLanguage === "ar" ? "en-US" : "en-US";

  // Get premium data from Redux
  const premiumData = useSelector(selectDomesticHelperPremium);

  return (
    <div className="plan-selection w-full">
      <DomesticHelperJourneyLayout
        is_hide_back_btn={false}
        customBackHandler={handlePrevSubstep}
      >
        <div className="content min-w-[32%] max767:w-full">
          <h1 className="text-[#1A2024] text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] text-center max767:text-left">
            {translate("Plan Selection", "اختيار الخطة")}
          </h1>
          <p className="text-[#1A2024] text-base not-italic font-normal leading-6 tracking-[-0.16px] text-center mt-1 mb-6 max767:text-left">
            {translate(
              "Choose the right insurance plan for your domestic helper",
              "اختر الخطة التأمينية المناسبة لعاملتك المنزلية"
            )}
          </p>
        </div>
        <DomesticHelperBottomStickyBtnLayout
          btn_onClick={handleNextStep}
          addonComponent={
            premiumData.isCalculated && (
              <div className="mr-10 mt-3 max767:w-full max767:flex max767:mb-2 max767:justify-between ipad:mt-0 rtl:ml-10 rtl:mr-0">
                <span className="text-[#00384D] text-center text-base not-italic font-semibold leading-[26px] tracking-[-0.16px] underline mr-10 rtl:ml-10 rtl:mr-0">
                  {translate("Show Summary", "عرض التسعيرة")}
                </span>
                <strong className="text-[#1A2024] text-xl not-italic font-extrabold leading-6">
                  {formatPremiumWithCurrency(
                    premiumData.totalPremium,
                    translate("BHD", "د.ب"),
                    currentLocale
                  )}
                </strong>
              </div>
            )
          }
        >
          <div className="w-[32%] max767:w-full mx-auto ipad:w-[60%] p-8 text-center">
            <p className="text-gray-600">Plan selection coming soon...</p>
            <p className="text-sm text-gray-500 mt-2">
              Basic, Standard, Premium plans with benefits comparison
            </p>
          </div>
        </DomesticHelperBottomStickyBtnLayout>
      </DomesticHelperJourneyLayout>
    </div>
  );
};

export default PlanSelection;
